import React, { useCallback, useState } from "react";
import Layout from "../../components/Layout/Layout";
import NewsServices from "./../../services/NewsServices";
import fire from "./../../utils/Toastr";

export default function Promotion() {
  const initialFormValues = {
    targetAudience: "All",
    title: "",
    content: "",
    image: null,
    targetedUserName: "",
  };

  const initialFormErrors = {
    titleError: "",
    contentError: "",
    imageError: "",
    titleIsValidated: false,
    contentIsValidated: false,
    imageIsValidated: false,
    formIsSubmitting: false,
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState(initialFormErrors);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTitleChange = (event) => {
    const title = event.target.value;
    setFormValues((prev) => ({
      ...prev,
      title,
    }));

    if (title.trim().length < 1) {
      setFormErrors({
        ...formErrors,
        titleError: "Title cannot be empty",
        titleIsValidated: false,
      });
    } else {
      setFormErrors({
        ...formErrors,
        titleError: "",
        titleIsValidated: true,
      });
    }
  };

  const handleContentChange = (event) => {
    const content = event.target.value;
    setFormValues((prev) => ({
      ...prev,
      content,
    }));

    if (content.trim().length < 1) {
      setFormErrors({
        ...formErrors,
        contentError: "Content cannot be empty",
        contentIsValidated: false,
      });
    } else {
      setFormErrors({
        ...formErrors,
        contentError: "",
        contentIsValidated: true,
      });
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    setFormValues((prev) => ({
      ...prev,
      image: file,
    }));
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate fields
    let valid = true;

    if (formValues.title.trim().length < 1) {
      setFormErrors((prev) => ({
        ...prev,
        titleError: "Title cannot be empty",
        titleIsValidated: false,
      }));
      valid = false;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        titleError: "",
        titleIsValidated: true,
      }));
    }

    if (formValues.content.trim().length < 1) {
      setFormErrors((prev) => ({
        ...prev,
        contentError: "Content cannot be empty",
        contentIsValidated: false,
      }));
      valid = false;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        contentError: "",
        contentIsValidated: true,
      }));
    }

    if (!formValues.image) {
      setFormErrors((prev) => ({
        ...prev,
        imageError: "Image is required",
        imageIsValidated: false,
      }));
      valid = false;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        imageError: "",
        imageIsValidated: true,
      }));
    }

    if (!valid) {
      setLoading(false);
      fire("error", "Please fill in all required fields.");
      return;
    }

    // Prepare form data
    const formData = new FormData();
    formData.append("targetAudience", formValues.targetAudience);
    formData.append("content", formValues.content);
    formData.append("title", formValues.title);
    if (formValues.image) {
      formData.append("image", formValues.image);
    }

    try {
      const response = await NewsServices.createPromotion(formData);
      if (response) {
        fire("success", response.message);
        setTimeout(() => {
          window.location.href = "/posts";
        }, 2000);
      }
    } catch (error) {
      fire("error", "An error occurred while submitting the form");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout pageTag={"news"} current={"/promotion"}>
      <main>
        <div className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">News Feed</h1>
          </div>
        </div>
        <div className="blog w-[70vw] min-w-[400px] mx-auto py-[20px]">
          <input
            type="text"
            value={formValues.title}
            onChange={handleTitleChange}
            className="title w-full min-h-[50px] text-[50px] font-semibold text-[#2d2d2d] resize-none border-none p-2.5 rounded-[10px] placeholder-[#2d2d2d] outline-none"
            placeholder="News title..."
          />
          {formErrors.titleError && (
            <p className="text-red-500 text-sm">{formErrors.titleError}</p>
          )}
          <textarea
            value={formValues.content}
            onChange={handleContentChange}
            className="article w-full h-[200px] text-[20px] leading-[30px] font-medium text-[#2d2d2d] resize-none border-none p-2 mt-4 rounded-[10px] placeholder-[#2d2d2d] outline-none"
            placeholder="Start writing here..."
          ></textarea>
          {formErrors.contentError && (
            <p className="text-red-500 text-sm">{formErrors.contentError}</p>
          )}
          <div className="blog-options bottom-0 left-0 w-full h-[60px] bg-white z-[9] flex justify-center items-center">
            <button
              onClick={handleSubmit}
              className="btn dark publish-btn bg-gray-800 text-white py-2 px-4 rounded-[10px]"
            >
              {loading ? "Loading...." : "Publish"}
            </button>
            <input
              type="file"
              accept="image/*"
              id="image-upload"
              onChange={(e) => onDrop(e.target.files)}
              hidden
            />
            <label
              htmlFor="image-upload"
              className="btn grey flex upload-btn bg-gray-500 text-white ml-4 p-2 px-4 rounded-[10px]"
            >
              Upload
            </label>
            {formErrors.imageError && (
              <p className="text-red-500 text-sm">{formErrors.imageError}</p>
            )}
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="w-32 h-32 object-cover ml-4 rounded flex flex-col"
              />
            )}
          </div>
        </div>
      </main>
    </Layout>
  );
}
